import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { IdentityService } from '../services/identity/identity.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const identity = inject(IdentityService);
  const jwt = identity.getToken();
  let token = null;
  if (jwt)
    token = jwt.token;

  //let urlCheck = "https://realtime";
  let urlCheck = "rivalforge.com";

  // Add the access token if its a kloudnest url.
  // Exception: s3 buckets.
  if (token && req.url.includes(urlCheck) && !req.url.startsWith("https://s3")) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req);
};
